import { cubicOut } from 'eases-jsnext';

export const customFly = (node, {
  delay = 0,
  duration = 400,
  easing = cubicOut,
  x = 0,
  y = 0
} = {}) => {
  const style = getComputedStyle(node);
  const opacity = +style.opacity;
  const transform = style.transform === 'none' ? '' : style.transform;

  return {
    delay,
    duration,
    easing,
    css: t => {
      const styles = `
        transform: ${transform} translate(${(1 - t) * x}px, ${(1 - t) * y}px);
        opacity: ${t * opacity}`;
      /* we do this to avoid growing the container
       * while both pages are in the dom.
       */
      return  t === 0 ? 'display: none; opacity: 0;' : styles;
    }
  };
};
